import type { MarketRankEnded, MarketRankLive } from "@roman/shared/types/PredictionMarket";
import { cn } from "@roman/shared/utils";
import { RankingRow } from "./RankingRow";

interface ChoiceRankingProps {
  slice?: number;
  avatarSize?: string;
  titleFontSize?: string;
  isShowUserNameTitle?: boolean;
  isShowRankTitle?: boolean;
  participantChoiceRanks: MarketRankLive["ranks"] | MarketRankEnded["ranks"];
  isEnd?: boolean; // Indicates if the ranking is for an ended market
}

export const ChoiceRanking = ({
  participantChoiceRanks,
  slice = 5, // Default to showing top 5 participants
  isShowUserNameTitle = true,
  isShowRankTitle = true,
  titleFontSize = "text-[10px]",
  avatarSize = "w-[36px] h-[36px]",
}: ChoiceRankingProps) => (
  <div className="" data-orientation="vertical">
    {/* Header Row */}
    <div className={cn("flex items-end border-b border-light-gray pb-[9px] bg-white z-10 h-[64px]")}>
      <div className="flex justify-between w-full">
        <div className={`w-6 text-dark-gray font-normal leading-[14px] tracking-[-0.2px] text-center ${titleFontSize}`}>
          {isShowRankTitle ? "順位" : ""}
        </div>
        <div
          className={`flex items-center gap-2 flex-1 pl-[46px] text-dark-gray font-normal leading-[14px] tracking-[-0.2px] text-center ${titleFontSize}`}
        >
          {isShowUserNameTitle ? "ユーザー" : ""}
        </div>
        <div
          className={`w-24 text-dark-gray font-normal leading-[14px] tracking-[-0.2px] text-center ${titleFontSize}`}
        >
          合計
        </div>
      </div>
    </div>

    {/* User Rows */}
    {participantChoiceRanks.slice(0, slice).map((participantChoiceRank) => (
      <RankingRow
        avatarSize={avatarSize}
        key={participantChoiceRank.userId}
        participantChoiceRank={participantChoiceRank}
      />
    ))}
  </div>
);
